import { Component, Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, tap, switchMap } from 'rxjs/operators';
import { RequestsService } from "@app/core/services";

@Component({
  selector: 'typeahead-http-done',
  templateUrl: 'typeahead-done.component.html',
  providers: [RequestsService],
})
export class NgbdTypeaheadHttpDone {
  model: any;
  searching = false;
  searchFailed = false;
  @Output() modelOutput = new EventEmitter();

  constructor(private _service: RequestsService) { }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term =>
        this._service.searchDone(term).pipe(
          tap(() => this.searchFailed = false),
          catchError(() => {
            this.searchFailed = true;
            return of([]);
          }))
      ),
      tap(() => this.searching = false)
    )

  formatter = (x: { Id_Comercial: string }) => {
    x.Id_Comercial
    //console.log(x)
    this.modelOutput.emit(x);
  };
}